import React, { createContext, useContext, useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from "react-router-dom";

const FilterContext = createContext();
export const useFilterContext = () => useContext(FilterContext);
export const FilterContextProvider = ({ children , name}) => {

    const location = useLocation();
    const navigate = useNavigate();
    const searchParams = new URLSearchParams(location.search);

    const [filterValue, setFilterValue] = useState('');
    const timeoutIdRef = useRef(null); // Use useRef to keep track of timeoutId

    const debounce = (func, delay) => {
        return (...args) => {
            if (timeoutIdRef.current) {
                clearTimeout(timeoutIdRef.current);
            }
            timeoutIdRef.current = setTimeout(() => {
                func(...args);
            }, delay);
        };
    };

    const updateURLParams = (parameter, value, debounceTime = 0) => {
        if (!parameter) {
            return;
        }
        const updateParams = () => {
            const searchParams = new URLSearchParams(location.search);
            searchParams.set(parameter, value);
            searchParams.set('page', '1');
            navigate(`${location.pathname}?${searchParams.toString()}`);
        };

        if (debounceTime > 0) {
            const debouncedUpdate = debounce(updateParams, debounceTime);
            debouncedUpdate();
        } else {
            updateParams();
        }
    };

    const resetFilters = () => {
        const searchParams = new URLSearchParams(location.search);
        const perPage = searchParams.get('per_page');
        const newSearchParams = new URLSearchParams();
        if (perPage) {
            newSearchParams.set('per_page', perPage);
        }
        // Full reload rather than navigate() so each filter control re-seeds its
        // local state from the cleared params. The target is built on
        // window.location.origin and never on a raw string, so the path can't
        // carry a scheme (javascript:, data:) or a foreign host into the
        // navigation; anything that still resolves off-origin is dropped.
        const target = new URL(window.location.origin);
        target.pathname = location.pathname;
        target.search = newSearchParams.toString();
        if (target.origin !== window.location.origin) {
            return;
        }
        window.location.assign(target.toString());
    };

    // Set default filter value
    useEffect(() => {
        const filterParam = searchParams.get(name);
        if (filterParam) {
            setFilterValue(filterParam);
        }
    }, []);


    return (
        <FilterContext.Provider value={{
            name,
            filterValue,
            setFilterValue,
            updateURLParams,
            resetFilters }}>
            {children}
        </FilterContext.Provider>
    );
};